import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { HolidayValidationSchema } from '../schemas/create.schema'
interface UseCreateHolidayProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useCreateHoliday = ({ onSuccess, onError  }: UseCreateHolidayProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createHoliday'],
    mutationFn: async (form: HolidayValidationSchema) => {
      const { geo, ...rest } = form

      const holiday = {
        ...rest,
        geo_type: geo.type,
        geo_id: geo.value
      }

      return privateAxios.post('/calendar/holidays', { holiday })
    },
    onSuccess,
    onError,
  })
}

export default useCreateHoliday
